/**
 * Font model class — drop-in replacement for ngx-font-picker's Font class.
 * Retains the same public API so backend schema and live-site rendering
 * remain 100 % compatible.
 */
export interface FontInterface {
    size: string;
    style: string;
    family: string;
    files?: any;
    styles?: string[];
}

export class Font implements FontInterface {
    public size: string = '16px';
    public style: string = 'regular';
    public family: string = 'monospace';
    public files: any = null;
    public styles: string[] = ['regular'];

    constructor(props?: Partial<FontInterface>) {
        if (props) {
            this.size = props.size || '16px';
            this.style = props.style || 'regular';
            this.family = props.family || 'monospace';
            this.files = props.files || null;
            this.styles = props.styles || ['regular'];
        }
    }

    /**
     * Returns an ngStyle-compatible object for previewing the font.
     * This mirrors the original ngx-font-picker implementation exactly.
     */
    public getStyles(): any {
        return {
            'font-size': this.size || '16px',
            'font-style': this.style.includes('italic') ? 'italic' : 'normal',
            'font-family': this.family || 'monospace',
            'font-weight': isNaN(Number(this.style.slice(0, 3)))
                ? 'normal'
                : this.style.slice(0, 3),
        };
    }
}
